<!-- 无人机配送 -->
<template>
    <MainLayout :hasLeft="false" :hasRight="false">
        <News slot="header" :weatherDialogProps="weatherDialogProps"></News>
        <el-container slot="main" class="wl-dashboard">
            <el-header class="wl-dashboard__header">
                <div class="header-location" style="height:100%;flex-shrink: 0;">
                    <el-dropdown placement="bottom" @command="handleCurrentSiteChange">
                        <span class="el-dropdown-link">
                            <i class="el-icon-location-outline"></i>
                            <span>{{ currentSite.name }}</span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item) in siteList" :key="item.id" :command="item">
                                <div>
                                    <span>{{ item.name }}</span>
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </div>
                <div class="header-tab">
                    <Tabs v-for="(item, index) in siteStatics" :key="index" :tab="item"></Tabs>
                    <!-- <ul class="header-statistics">
                        <li v-for="(item, index) in takeoutStatics.statusCount" :key="index"
                            class="header-statistics__item">
                            <span class="header-statistics__item-name">{{ item.name }}</span>
                            <span class="header-statistics__item-value">{{ item.value }}</span>
                        </li>
                    </ul>
                    <ul class="header-statistics">
                        <li v-for="(item, index) in takeoutStatics.statusCount" :key="index"
                            class="header-statistics__item">
                            <span class="header-statistics__item-name">{{ item.name }}</span>
                            <span class="header-statistics__item-value">{{ item.value }}</span>
                        </li>
                    </ul> -->
                </div>
            </el-header>
            <el-container class="wl-dashboard__main">
                <el-aside width="280px" class="aside-left">
                    <div style="padding: 0px;height:100%;">
                        <LeftAside ref="leftAside" :startSiteId="currentSite.id" @selectSite="handleLeftSiteSelect" />
                    </div>
                </el-aside>
                <el-main style="padding:0 10px ;height:100%;position: relative;">
                    <el-row :gutter="20" style="height: calc(100% - 0px);">
                        <el-col :span="17" class="main-left">
                            <div class="main-left__content">
                                <CTransfer v-model="selected" :data="transferData" :props="{ key: 'id' }"
                                    :format="{ noChecked: '${total} ', hasChecked: '${total}' }"
                                    :rightProps="transferRightProps" :render-content="renderFunc"
                                    :emptyText="transferEmptyText" :show-check-all="false" :multiple="false"
                                    :show-buttons="false" :footer-height="40" filterable
                                    :filterMethod="transferFilterMethod" :left-loading="loadingInfo.isTakeoutLoading"
                                    :beforeAddToRight="beforeAddToRight" :beforeAddToLeft="beforeAddToLeft"
                                    @change="handleTransferChange">
                                    <template v-slot:left-header>
                                        <div class="card-title" style="padding: 0 5px; color:#ffffff">
                                            <i class="el-icon-caret-right" style="color: #EF8200;"></i>
                                            <span style="font-size: 16px;">{{ $t('wuliu.index.takeoutOrderList') }}</span>

                                            <span style="cursor: pointer;margin-left: 8px;"
                                                @click="getTakeoutOrderList">
                                                <i v-if="!loadingInfo.isTakeoutLoading" class="el-icon-refresh"></i>
                                                <i v-else class="el-icon-loading"></i>
                                            </span>
                                            <span style="margin-left: 10px;">
                                                <span style="font-size: 12px;margin-right: 4px;">{{ $t('wuliu.index.voiceTip') }}</span>
                                                <el-switch v-model="audioUnlocked" :active-text="$t('wuliu.common.on')" :inactive-text="$t('wuliu.common.off')"
                                                    active-color="#13ce66" @change="initAudio" :width="34">
                                                </el-switch>
                                            </span>

                                        </div>
                                    </template>

                                    <div slot="right-header">
                                        <div class="card-title" style="padding: 0 5px ;">
                                            <span style="color:#ffffff">
                                                <i class="el-icon-caret-right" style="color: #EF8200;"></i> {{ $t('wuliu.index.deliveryList') }}
                                            </span>
                                            <span v-if="currentDeliveryOrder" style="font-size: 12px;color:#ffffff">
                                                (
                                                <span style="padding-right: 6px;">{{ $t('wuliu.index.deliveryOrderNo') }}</span>
                                                <span>{{ currentDeliveryOrder.code }}</span>
                                                )
                                            </span>
                                        </div>
                                    </div>
                                    <!--
                                        <div slot="right-footer" style="text-align: center;">
                                            <span style="display: inline-block;margin-right: 12px;">共 {{ selected.length }} 个订单</span>
                                        <el-button type="primary" size="mini" :loading="loadingInfo.isSaving"
                                            @click="handleSaveDeliveryOrderClick">生成配送单</el-button>
                                        </div>
                                        -->
                                </CTransfer>

                            </div>

                        </el-col>

                        <el-col :span="7" class="main-right">
                            <div class="main-right__content">
                                <div class="card-title right-card-title" style="color:#ffffff">
                                    <span>
                                        <i class="el-icon-caret-right" style="color: #EF8200;"></i>{{ $t('wuliu.index.deliveryOrderList') }}
                                    </span>
                                    <el-button class="right-card-title__btn" icon="el-icon-plus" size="mini"
                                        type="primary" @click="handleAddOrderBtnClick">
                                        {{ $t('wuliu.common.add') }}
                                    </el-button>
                                </div>
                                <!--  -->
                                <CustomElScrollbar v-loading="loadingInfo.deliveryLoading"
                                    style="height: calc(100% - 40px);" :element-loading-text="$t('wuliu.common.loading')"
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(0, 0, 0, 0.5)" class="d-scrollbar">
                                    <div>
                                        <DeliveryOrderItem v-for="item in deliveryOrderList" :key="item.id" :data="item"
                                            :uavList="uavList" :btnsConfig="btnsConfig"
                                            @click="handleDeliveryOrderClick" @delete="handleDeliveryOrderDelete"
                                            :isSelected="!!currentDeliveryOrder && item.id == currentDeliveryOrder.id"
                                            @detail="handleDeliveryOrderDetail" :refreshData="getDeliveryOrderList" />

                                    </div>
                                    <el-empty v-if="deliveryOrderList.length == 0" :description="$t('wuliu.index.emptyTodayDelivery')"
                                        style="height: 100%;">
                                        <div slot="image">

                                        </div>
                                    </el-empty>
                                </CustomElScrollbar>

                            </div>

                        </el-col>

                    </el-row>
                </el-main>
                <el-drawer :visible.sync="drawerVisible" :title="$t('wuliu.index.deliveryDetail')" :size="400" append-to-body direction="rtl"
                    class="order-item-detail-drawer">
                    <div style="padding:0 16px;height: calc(100% - 30px);position: relative;">
                        <CustomElScrollbar style="height: 100%;">
                            <DeliveryOrderDetail v-if="drawerVisible && currentDetailDeliveryOrder"
                                :id="currentDetailDeliveryOrder.id" />
                        </CustomElScrollbar>
                    </div>
                </el-drawer>
            </el-container>
        </el-container>

    </MainLayout>
</template>

<script>
import LeftAside from './components/LeftAside.vue';
import CTransfer from './components/transfer';
import OrderItem from '../components/OrderItem/OrderItem.vue';
import DeliveryOrderItem from '../components/OrderItem/DeliveryOrderItem.vue';
import CustomElScrollbar from '@/components/custom-el-scrollbar/CustomElScrollbar.vue';
import Tabs from './components/Tabs.vue';

import News from '@/page/mainPage/components/news/News.vue';
import MainLayout from '@/components/layout';
import SiteApi from '@/page/business/wuliu/api/site';
import OrderApi from '@/page/business/wuliu/api/order';
import CustomMarquee from '@/components/custom-marquee';

import DeliveryOrderDetail from '../components/DeliveryOrderDetail.vue';
import DateUtil from '@/utils/DateUtil';

export default {
    components: {
        LeftAside,
        CTransfer,
        OrderItem,
        DeliveryOrderItem,
        CustomElScrollbar,
        MainLayout,
        News,
        CustomMarquee,
        DeliveryOrderDetail,
        Tabs,

    },
    props: {},

    data() {
        document.title = this.$t('wuliu.index.pageTitle');
        return {
            siteList: [],
            currentSite: {}, // 当前配货站点信息
            currentTakeoutSite: {}, // 当前取货站点信息
            selected: [],

            orderList: [],
            orderMap: {}, // 订单map，key为订单id，value为订单信息

            renderFunc: (h, option, customProps) => {
                let props = customProps || {};
                return h(OrderItem, {
                    props: { data: option, ...props },
                    on: {
                        accept: this.handleOrderItemAcceptClick,
                        splitClick: this.handleOrderItemSplitClick,
                        cancelClick: this.handleOrderItemCancelClick,
                    },
                });
            },
            deliveryOrderList: [],
            currentDeliveryOrder: '', // 当前选中的配送单
            currentDetailDeliveryOrder: '', // 当前要查看详情单配送单
            cacheOrderList: [], // 缓存的订单列表(点击的配送单选择的外卖订单列表),主要是点击配送单时的订单列表，用于切换配送单时，恢复到之前的订单列表
            loadingInfo: {
                isTakeoutLoading: false, // 是否正在加载外卖订单列表
                deliveryLoading: false, // 是否正在加载配送单列表
                isSaving: false, // 是否正在保存配送单
            },
            uavList: [], // 无人机选项列表
            drawerVisible: false, // 配送单详情抽屉是否可见
            timerId: null, // 定时刷新数据定时器id
            staticsData: {}, // 当前配送站点统计数据
            // 传给穿梭框右侧列表item 的props
            transferRightProps: {
                showSplitBtn: false,
            },
            btnsConfig: {
                takeoff: false, // 起飞按钮
                simulateTakeoff: false, // 模拟起飞按钮
            },
            msgAudio: null, // 新订单提示音
            audioUnlocked: false, // 音频是否解锁
            hasNewOrder: false, // 是否有新订单
            isAudioPlayed: true, // 提示音是否已播放
        };
    },
    computed: {
        transferData() {
            const map = new Map();

            // 先合并两个列表
            const all = [...(this.orderList || []), ...(this.cacheOrderList || [])];

            all.forEach((item) => {
                if (!map.has(item.id)) {
                    map.set(item.id, item); // 按 id 去重
                }
            });

            return Array.from(map.values());
        },
        // 站点统计数据
        siteStatics() {
            let list = [
                {
                    name: this.$t('wuliu.index.takeoutOrder'),
                    completedCount: 0,
                    totalCount: 0,
                    uncompletedCount: 0,
                    statusCount: [],
                },
                {
                    name: this.$t('wuliu.index.deliveryOrder'),
                    completedCount: 0,
                    totalCount: 0,
                    uncompletedCount: 0,
                    statusCount: [],
                },
            ];
            if (!this.staticsData) {
                return list;
            }
            console.log('this.staticsData', this.staticsData);
            if (this.staticsData.takeoutOrderData) {
                console.log('外卖订单统计数据', this.staticsData.takeoutOrderData);

                list[0] = {
                    ...this.staticsData.takeoutOrderData,
                    name: this.$t('wuliu.index.takeoutOrder'),
                    statusCount: this.staticsData.takeoutOrderData.statusCount.slice(0, 6),
                };
            }
            if (this.staticsData.deliveryOrderData) {
                const targetIndexes = [0, 2, 3, 4, 6];
                list[1] = {
                    ...this.staticsData.deliveryOrderData,
                    name: this.$t('wuliu.index.deliveryOrder'),
                    statusCount: targetIndexes.map((index) => this.staticsData.deliveryOrderData.statusCount[index]),
                };
            }
            console.log(list, '外卖订单统计数据');
            return list;
        },
        transferEmptyText() {
            let rightText = this.$t('wuliu.index.selectTakeoutFromLeft');
            if (this.currentDeliveryOrder) {
                rightText = this.$t('wuliu.index.selectDeliveryTakeoutFromLeft');
            } else {
                rightText = this.$t('wuliu.index.selectDeliveryFirst');
            }
            return {
                left: this.$t('wuliu.index.emptyTodayTakeout'),
                right: rightText,
            };
        },
        // 天气弹窗props
        weatherDialogProps() {
            let res = {
                showDefaultText: true,
                useWeatherStation: true,
                weatherStationId: '',
                weatherDeviceSn: '',
            };
            if (this.currentTakeoutSite) {
                res.weatherStationId = this.currentTakeoutSite.id || '';
                res.weatherDeviceSn = this.currentTakeoutSite.weatherDeviceSn || '';
            }

            return res;
        },
    },
    methods: {
        /**
        * 处理当前站点变更
        *
        * @param site 当前站点信息
        */
        handleCurrentSiteChange(site) {
            this.currentSite = site;
            this.getCurrentSiteStaticsData();
        },

        /**
        * 处理左侧站点 点击选择事件
        *
        * @param site 选中的站点对象
        */
        handleLeftSiteSelect(site) {
            console.log(site);
            const self = this;
            if (this.selected.length > 0) {
                // 存在已选择订单，二次确认
                // this.$confirm('【确认配送清单】还没生成配送单, 切换将清空【确认配送清单】，是否继续?', '提示', {
                //   confirmButtonText: '确定',
                //   cancelButtonText: '取消',
                //   type: 'warning'
                // }).then(() => {
                //   this.selected = [];
                //   this.currentTakeoutSite = site;
                //   this.getTakeoutOrderList();
                //   this.getDeliveryOrderList();
                // }).catch(() => {
                //   if (self.$refs.leftAside) {
                //     self.$refs.leftAside.resetCurrentSite()
                //   }
                // });
                this.selected = [];
                this.currentTakeoutSite = site;
                this.currentDeliveryOrder = '';
                this.cacheOrderList = [];
                this.getTakeoutOrderList();
                this.getDeliveryOrderList();
            } else {
                this.currentTakeoutSite = site;
                this.currentDeliveryOrder = '';
                this.getTakeoutOrderList();
                this.getDeliveryOrderList();
            }
        },
        /**
        * 处理配送单点击事件
        *
        * @param item 配送单对象
        */
        handleDeliveryOrderClick(data) {
            if (data) {
                this.currentDeliveryOrder = data;
                const { id } = data;
                this.cacheOrderList = [];

                OrderApi.fetchDeliveryOrderInfo(id).then((res) => {
                    // console.log(res, "配送单详情")
                    const resData = res.data || {};
                    if (res.code == 200 && resData) {
                        let itemList = resData.itemList || [];
                        let ids = [];
                        let orderListIds = this.orderList.map((item) => item.id);
                        let toAddList = [];
                        const deliveryOrderStatus = Number(resData.status);
                        itemList.forEach((item) => {
                            if (deliveryOrderStatus > 0) {
                                // 如果配送单状态大于0，说明已配送，禁用外卖订单不可选，不让外卖订单在穿梭框左右移动
                                item.disabled = true;
                            }
                            ids.push(item.id);
                            if (!orderListIds.includes(item.id)) {
                                toAddList.push(item);
                            }
                        });

                        this.selected = ids;
                        this.cacheOrderList = toAddList;
                        // console.log(this.selected, "selected")
                    }
                });
            }
        },
        /**
        * 处理传transfer 穿梭框变化事件
        *
        * @param evt 事件对象
        */
        handleTransferChange(evt) {
            // console.log(evt);
        },
        handleSaveDeliveryOrderClick() {
            if (this.selected.length === 0) {
                this.$message({
                    message: this.$t('wuliu.index.pleaseAddOrder'),
                    type: 'warning',
                });
                return;
            }
            // if (!this.selectedUav) {
            //   this.$message({
            //     message: '请选择无人机',
            //     type: 'warning'
            //   })
            //   return
            // }
            let itemList = [];
            this.selected.forEach((item) => {
                itemList.push({
                    id: item,
                    type: 'T', // 货品类别，T：外卖，当前默认只有外卖
                });
            });
            let selectedOrderCode = [];
            this.orderList.forEach((item) => {
                if (this.selected.includes(item.id)) {
                    selectedOrderCode.push(item.code);
                }
            });
            let content = this.$t('wuliu.index.takeoutOrderNos', { codes: selectedOrderCode.join(',') });
            let params = {
                content,
                startSiteId: this.currentSite.id,
                endSiteId: this.currentTakeoutSite.id,
                itemList,
            };
            this.loadingInfo.isSaving = true;
            setTimeout(() => {
                this.loadingInfo.isSaving = false;
            }, 1000 * 5);
            OrderApi.fetchDeliveryOrderSave(params).then((res) => {
                this.loadingInfo.isSaving = false;
                if (res.code == 200) {
                    this.$message({
                        message: this.$t('wuliu.common.saveSuccess'),
                        type: 'success',
                    });
                    this.getDeliveryOrderList();
                }
            });
        },

        /**
        * 获取配货站点列表
        *
        * @method getDeliverySiteList
        * @returns {void} 无返回值
        */
        getDeliverySiteList() {
            let params = {
                type: 'D', // 站点类型   D：配货站点   T：取货站点
            };
            SiteApi.fetchSiteList(params).then((res) => {
                if (res.code == 200) {
                    this.siteList = res.rows || [];
                    if (this.siteList.length > 0) {
                        // this.currentSite = this.siteList[0];
                        this.handleCurrentSiteChange(this.siteList[0]);
                    }
                }
            });
        },
        /**
        * 获取外卖订单列表
        *
        * @returns 无返回值
        */
        getTakeoutOrderList() {
            if (!this.currentTakeoutSite || !this.currentTakeoutSite.id) return;
            const { beginTime, endTime } = this.getQueryTime();
            let params = {
                startSiteId: this.currentSite.id,
                takeSiteId: this.currentTakeoutSite.id,
                beginTime,
                endTime,
                status: '0,1', // 订单状态  0：待出餐  1：已接单
                orderByColumn: 'status',
                isAsc: 'desc', // 是否升序  asc：升序，desc：降序

            };
            this.loadingInfo.isTakeoutLoading = true;
            setTimeout(() => {
                this.loadingInfo.isTakeoutLoading = false;
            }, 1000 * 5);
            OrderApi.fetchUnhandledTakeoutOrderList(params).then((res) => {
                this.loadingInfo.isTakeoutLoading = false;
                let list = [];
                if (res.code == 200) {
                    list = res.rows || res.data || [];
                }
                const oldOrderMap = this.orderMap || {};
                const newOrderMap = {};

                let hasNewOrder = false;
                list.forEach((item) => {
                    item.disabled = item.status !== '1';
                    newOrderMap[item.id] = item;
                    // 👉 新列表里有，但旧 map 里没有 = 新订单
                    if (!oldOrderMap[item.id]) {
                        hasNewOrder = true;
                    }
                });
                if (this.isAudioPlayed) {
                    this.hasNewOrder = hasNewOrder;
                    this.isAudioPlayed = false;
                }
                // 👉 旧的有，新列表没有的，直接被 newOrderMap 覆盖掉（等于删除）
                this.orderMap = newOrderMap;
                this.orderList = list;

                // 👉 统一在最后提示
                if (this.hasNewOrder) {
                    this.playAudio(); // 播放提示音 / 提示消息
                }
            });
        },
        /**
        * 在将外卖订单添加到右侧列表之前，执行的异步操作，调用api接口把外卖订单添加到选定的配送单中
        *
        * @returns 返回布尔值，true 表示检查通过，false 表示检查失败。
        */
        async beforeAddToRight(value, data) {
            if (!this.currentDeliveryOrder) {
                this.$message({
                    message: this.$t('wuliu.index.selectDeliveryFirst'),
                    type: 'warning',
                });
                return false;
            }
            let param = {
                orderId: this.currentDeliveryOrder.id,
                // bizId: value,
                bizIdList: value,
                bizType: 'T', // 货品类别，T：外卖，当前默认只有外卖
            };
            const response = await OrderApi.fetchDeliveryOrderAddItem(param);

            if (response.code != 200) {
                this.$message({
                    message: response.msg,
                    type: 'error',
                });
                return false;
            }
            this.getDeliveryOrderList();
            return true;
        },
        /**
        * 在将配送清单添加到左侧之前执行的异步操作，调用api接口把订单从配送单中移除
        *
        * @returns 如果当前有配送单且异步操作成功，则返回 true；否则返回 false
        */
        async beforeAddToLeft(value, data) {
            if (!this.currentDeliveryOrder) {
                this.$message({
                    message: this.$t('wuliu.index.selectDeliveryFirst'),
                    type: 'warning',
                });
                return false;
            }
            let param = {
                orderId: this.currentDeliveryOrder.id,
                // bizId: value,
                bizIdList: value,
                bizType: 'T', // 货品类别，T：外卖，当前默认只有外卖
            };
            const response = await OrderApi.fetchDeliveryOrderRemoveItem(param);

            if (response.code != 200) {
                this.$message({
                    message: response.msg,
                    type: 'error',
                });
                return false;
            }
            // this.selected = [];
            // setTimeout(() => {

            // this.selected = [];
            this.getDeliveryOrderList();
            this.getTakeoutOrderList();

            // }, 100);

            return true;
        },
        /**
        * 处理订单确认接单点击事件
        *
        * @param data 订单数据对象
        */
        handleOrderItemAcceptClick(data) {
            const id = data.id;
            if (id) {
                OrderApi.fetchTakeoutTake(id).then((res) => {
                    if (res.code == 200) {
                        // 接单成功后，再次请求订单详情信息，更新订单状态等信息
                        OrderApi.fetchTakeoutOrderInfo(id).then((response) => {
                            if (response.code == 200) {
                                this.$message({
                                    message: this.$t('wuliu.index.acceptOrderSuccess'),
                                    type: 'success',
                                });
                                let newData = response.data || {};
                                newData.disabled = false;
                                Object.assign(data, newData);
                            }
                        });
                    }
                });
            }
        },
        // 处理订单拆分点击事件
        handleOrderItemSplitClick(event) {
            const { data, formData } = event;
            const id = data.id;
            if (id) {
                let params = {
                    id,
                    splitNum: formData.splitNum,

                };
                OrderApi.fetchSplitTakeoutOrder(params).then((response) => {
                    if (response.code == 200) {
                        this.$message({
                            message: this.$t('wuliu.index.splitOrderSuccess'),
                            type: 'success',
                        });
                        this.getTakeoutOrderList();
                    }
                });
            }
        },
        /**
        * 处理订单取消拆单点击事件
        *
        * @param data 订单数据对象
        */
        handleOrderItemCancelClick(data) {
            const id = data.id;
            if (id) {
                OrderApi.fetchCancelTakeoutOrder(id).then((res) => {
                    if (res.code == 200) {
                        this.$message({
                            message: this.$t('wuliu.index.cancelSplitSuccess'),
                            type: 'success',
                        });
                        this.getTakeoutOrderList();
                    }
                });
            }
        },
        /**
         * 新增配送单点击事件处理函数
         */
        handleAddOrderBtnClick() {
            let param = {
                content: this.$t('wuliu.index.takeoutDelivery'),
                startSiteId: this.currentSite.id,
                endSiteId: this.currentTakeoutSite.id,
                bizType: 'T', // 货品类别，T：外卖，当前默认只有外卖
            };
            OrderApi.fetchDeliveryOrderSave(param).then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: this.$t('wuliu.index.addDeliveryOrderSuccess'),
                        type: 'success',
                    });
                    if (res.data) {
                        this.currentDeliveryOrder = res.data;
                    }
                    this.getDeliveryOrderList();
                }
            });
        },
        handleDeliveryOrderDetail(data) {
            this.currentDetailDeliveryOrder = data;

            this.drawerVisible = true;
        },

        /**
        * 获取配送单列表
        */
        getDeliveryOrderList() {
            const { beginTime, endTime } = this.getQueryTime();
            let params = {
                endSiteId: this.currentTakeoutSite.id,
                // status: "0,1",//订单状态  0：待配送  1：已配送
                // orderByColumn: 'status',
                orderByColumn: 'orderTime',
                beginTime,
                endTime,
                isAsc: 'desc', // 是否升序  asc：升序，desc：降序
            };
            this.loadingInfo.deliveryLoading = true;

            setTimeout(() => {
                this.loadingInfo.deliveryLoading = false;
            }, 1000 * 5);
            OrderApi.fetchDeliveryOrderList(params).then((res) => {
                this.loadingInfo.deliveryLoading = false;
                this.deliveryOrderList = [];
                if (res.code == 200) {
                    this.deliveryOrderList = res.rows || [];
                    if (this.currentDeliveryOrder && this.currentDeliveryOrder.id) {
                        let newCurrentDeliveryOrder = this.deliveryOrderList.find((item) => item.id == this.currentDeliveryOrder.id);
                        this.handleDeliveryOrderClick(newCurrentDeliveryOrder);
                    }
                }
            });
        },
        /**
        * 删除配送单
        *
        * @param data 包含删除配送单所需信息的对象
        */
        handleDeliveryOrderDelete(data) {
            if (data) {
                OrderApi.fetchDeleteDeliveryOrder(data.id).then((res) => {
                    if (res.code == 200) {
                        this.$message({
                            message: this.$t('wuliu.index.deleteDeliveryOrderSuccess'),
                            type: 'success',
                        });
                        this.getDeliveryOrderList();
                    }
                });
            }
        },
        getUavList() {
            OrderApi.fetchDroneOptionList().then((res) => {
                if (res.code == 200) {
                    this.uavList = res.data || res.rows || [];
                }
            });
        },
        /**
        * 获取当前配送站点统计数据
        */
        getCurrentSiteStaticsData() {
            if (this.currentSite && this.currentSite.id) {
                const today = DateUtil.getToday('YYYY-MM-DD');
                const { beginTime, endTime } = this.getQueryTime();
                let params = {
                    siteId: this.currentSite.id,
                    beginTime,
                    endTime,
                };
                SiteApi.fetchSiteStatics(params).then((res) => {
                    // console.log('this.staticsData', res);
                    if (res.code == 200) {
                        this.staticsData = res.data || {};
                    }
                });
            }
        },
        getQueryTime() {
            const today = DateUtil.getToday('YYYY-MM-DD');
            // 最好是根据营业时间来定，这里默认是8点到23点59分59秒，这里暂时用这个时间段来统计数据
            let beginTime = `${today} 07:00:00`;
            const endTime = `${today} 23:59:59`;
            // 开发阶段暂时用一个月前的时间来调试
            // beginTime = DateUtil.getOneMonthAgo('YYYY-MM-DD 00:00:00');
            return {
                beginTime,
                endTime,
            };
        },
        /**
         * 定时刷新数据
         */
        refreshDataTimer() {
            clearInterval(this.timerId);
            this.timerId = setInterval(() => {
                this.getTakeoutOrderList();
                this.getDeliveryOrderList();
                this.getCurrentSiteStaticsData();
            }, 1000 * 60);
        },
        transferFilterMethod(query, item) {
            return item.merchant && item.merchant.indexOf(query) > -1 || item.code && item.code.indexOf(query) > -1;
        },
        initAudio(value) {
            if (value) {
                if (!this.msgAudio) {
                    const src = require('@/assets/sounds/new_order.mp3');
                    const msgAudio = new Audio(src);
                    this.msgAudio = msgAudio;
                    msgAudio.volume = 0.6;
                    msgAudio.preload = 'auto';
                }
                if (this.hasNewOrder) {
                    this.playAudio();
                }
            } else {
                this.stopPlayAudio();
            }
        },
        stopPlayAudio() {
            if (this.msgAudio) {
                this.msgAudio.pause();
                this.msgAudio.currentTime = 0;
            }
        },
        /**
         * 新订单提示
         */
        playAudio() {
            if (!this.audioUnlocked) return; // 防止报错
            if (this.msgAudio) {
                this.msgAudio.play();
                this.isAudioPlayed = true;
                this.hasNewOrder = false;
            }
        },

    },
    mounted() {
        this.getDeliverySiteList();
        this.getUavList();
        this.refreshDataTimer();
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
};
</script>

<style lang="scss" scoped>
// $bgColor: #071150;
// $bgColor2: #060e42;
$bgColor: #0D1541;
$bgColor2: #071150;
$colorLight: #5bf0fc;
$borderColor: #1A47A4;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.wl-dashboard {
    height: 100%;
    position: relative;
    background-color: $bgColor2;
    color: #ffffff;
    flex: 1;
    z-index: 1;

    &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        z-index: -2;
        position: absolute;
        top: 0px;
        left: 0px;
        background-color: $bgColor2;
    }

    &::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        z-index: -1;
        position: absolute;
        top: 0px;
        left: 0px;
        border: 56px solid;
        box-sizing: border-box;
        border-image: url("./images/bg_wrap.png") 56 56;
    }

    &__header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px #1A47A4 solid;
        margin: 0 10px;
        padding: 0;

        .header-tab {
            display: flex;
            align-items: center;

        }

    }

    .header-location {
        max-width: 200px;
        height: 100%;
        display: flex;
        align-items: center;

        .el-dropdown-link {
            cursor: pointer;
            color: #ffffff;
            font-size: 18px;
            font-weight: bold;
        }
    }

    &__main {
        height: calc(100% - 80px);
        position: relative;
        padding: 10px;

        .aside-left {
            background-color: $bgColor2;
            border: 1px solid $borderColor;
            border-radius: 4px;
        }

        .main-left {
            height: 100%;
            position: relative;

            &__content {
                height: 100%;

            }

        }

        ::v-deep.c-transfer {
            height: 100%;
            display: flex;
            align-items: center;

            &-panel {
                height: 100%;
                flex: 1;
                background-color: $bgColor2;
                border: 1px solid $borderColor;
                border-radius: 4px;

                &__header {
                    background-color: #060e42;
                }

                // &__item {
                //     border-bottom: 1px solid $borderColor;
                // }
                .order-info-content {
                    padding-right: 63px;
                }

                .el-switch__core {
                    height: 18px;

                    &::after {
                        width: 14px;
                        height: 14px;
                    }
                }

                .el-switch__label {
                    color: rgba(255, 255, 255, 0.7);
                }
            }

        }

        .main-right {
            height: 100%;
            position: relative;
            padding: 0 !important;

            &__content {
                height: 100%;
                background-color: $bgColor2;
                border: 1px solid $borderColor;
                border-radius: 4px;
                position: relative;
            }

        }
    }

    ::v-deep .card-title {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: $colorLight;
        padding: 0 5px;
        background: linear-gradient(270deg, rgba(10, 167, 255, 0) 0%, rgba(10, 167, 255, 0.22) 100%);
        border-radius: 2px;
    }

    .right-card-title {
        display: flex;
        align-items: center;

        &__btn {
            margin-left: auto;
            padding: 6px;
            color: #10163A;
            background: #49F0FD;

        }
    }

    .d-scrollbar {
        ::v-deep .el-scrollbar__view {
            height: 0px;
            min-height: 100%;

            .scrollbar__content {
                height: 100%;
            }
        }
    }

}
</style>
<style lang="scss">
$bgColor: #0D1541;
$bgColor2: #0D134F;
$colorLight: #5bf0fc;
$borderColor: #2e355b;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.order-item-detail-drawer {

    .el-drawer {
        background-color: $bgColor2;
        color: #ffffff;

        &__header {
            color: #ffffff;
            margin-bottom: 20px;
        }

        .el-form-item {
            &__label {
                color: rgba(255, 255, 255, 0.7);
                font-size: 12px;
            }
        }

        .el-timeline-item {
            &__content {
                color: #ffffff;
            }
        }

        .timeline-item__label {
            color: rgba(255, 255, 255, 0.7);
        }
    }
}
</style>
